/**
 * 角色与权限模块（OFBiz 新接口）
 * ------------------------------------------------------------------
 * 对应后端：POST /itoss/control/json/role/*
 *
 * 迁移自前端原接口（rest_client.js / setting_action.js / login_action.js）：
 *   getRoleList / getOrganizationRoleData -> /rest/security/role/names
 *   operateRole / deleteRole -> /rest/security/role/*
 *   getPermissionData / getRolePermission -> /rest/security/permission/*
 *   updatePermission -> /rest/security/permission/editrole
 *
 * 注意：/role/permissions 返回的是"所有可分配权限项清单"，
 * 不是"当前用户权限"。当前用户权限请用 auth.authMe() 返回的 permissions。
 */
import { ofbiz } from './http';

/**
 * 角色列表（替代旧 getRoleList / getOrganizationRoleData）
 * @param {object} [query]
 * @param {number} [page=1]
 * @param {number} [pageSize=20]
 * @returns {Promise<{list, total, page, pageSize}>}
 */
export function getRoleList(query = {}, page = 1, pageSize = 20) {
  return ofbiz.postPage('role/list', query, page, pageSize);
}

/**
 * 角色详情
 * @param {string} roleId
 * @returns {Promise<object>}
 */
export function getRoleById(roleId) {
  return ofbiz.post('role/getById', null, { roleId });
}

/**
 * 新增角色
 * @param {object} data
 * @returns {Promise<object>}
 */
export function createRole(data) {
  return ofbiz.post('role/create', data);
}

/**
 * 更新角色
 * @param {object} data 必含 roleId
 * @returns {Promise<object>}
 */
export function updateRole(data) {
  return ofbiz.post('role/update', data);
}

/**
 * 删除角色
 * @param {string} roleId
 * @returns {Promise<object>}
 */
export function deleteRole(roleId) {
  return ofbiz.post('role/delete', null, { roleId });
}

/**
 * 给角色分配权限（覆盖式，替代旧 updatePermission）
 * @param {string} roleId
 * @param {string|string[]} permissionIds 权限 ID，逗号分隔或数组
 * @returns {Promise<object>}
 */
export function assignPermissions(roleId, permissionIds) {
  const ids = Array.isArray(permissionIds) ? permissionIds.join(',') : permissionIds;
  return ofbiz.post('role/assignPermissions', null, { roleId, permissionIds: ids });
}

/**
 * 所有可分配权限项清单（permissionId + description）
 * 注意：这是"可选权限全集"，不是"当前用户/角色的权限"。
 * 当前用户权限请用 auth.authMe()。
 * @returns {Promise<Array>}
 */
export function getPermissionList() {
  return ofbiz.post('role/permissions');
}
